<div
  *ngIf="builderLeft === builderLeftTree"
  class="bg-m0 flex w-full flex-grow rounded shadow"
>
  <div class="text-s1 mt-6 flex w-full flex-col text-base">
    <div class="flex flex-1 flex-col">
      <div class="mb-6 flex h-11 flex-row items-center justify-between">
        <div class="flex flex-row items-center">
          <m-search-icon class="text-s1 ml-6"></m-search-icon>

          <input
            spellcheck="false"
            autocomplete="off"
            data-cy="dashboardsSearchInput"
            class="form-input focus:border-m600 border-s400 ml-3 h-10 w-[225px] select-none rounded"
            placeholder="Search Files"
            [ngClass]="{
              'bg-p200': !!word
            }"
            [(ngModel)]="word"
            (ngModelChange)="searchWordChange()"
          />

          <div class="h-9 w-9">
            <m-delete-icon
              *ngIf="!!word"
              class="text-s1 ml-3 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
              [ngClass]="{
                'bg-p200 hover:bg-p300 cursor-pointer': !!word
              }"
              (click)="resetSearch()"
            ></m-delete-icon>
          </div>
        </div>

        <ng-template #templateNewFile>
          <div *ngIf="isEditor === false"
            >Files can be edited by project members with FilesEditor role</div
          >

          <div
            *ngIf="
              isEditor === true && nav?.repoType === repoTypeEnum.Production
            "
            >Switch branch from Production repo to Dev repo to edit files</div
          >

          <div
            *ngIf="
              isEditor === true &&
              nav?.repoType !== repoTypeEnum.Production &&
              needSave === true
            "
            >Need to Save changes</div
          >
        </ng-template>

        <div
          [tp]="templateNewFile"
          [tpIsEnabled]="
            isEditor === false ||
            nav?.repoType === repoTypeEnum.Production ||
            needSave === true
          "
          class="mr-9 flex-shrink-0"
        >
          <button
            type="button"
            data-cy="filesAddFileButton"
            class="flex select-none flex-row items-center rounded border p-4 py-2 focus:outline-none"
            [ngClass]="{
              'border-s400 text-s500 hover:bg-s100':
                isEditor === true &&
                nav?.repoType !== repoTypeEnum.Production &&
                needSave === false,
              'border-s300 text-s400 cursor-default':
                isEditor === false ||
                nav?.repoType === repoTypeEnum.Production ||
                needSave === true
            }"
            (click)="newFileClick.emit()"
            [disabled]="
              isEditor === false ||
              nav?.repoType === repoTypeEnum.Production ||
              needSave === true
            "
          >
            <!-- <m-add-icon></m-add-icon> -->
            <!-- <div class="ml-1">New File</div> -->
            <div>New File</div>
          </button>
        </div>
      </div>

      <div class="divide-s300 ml-6 mr-9 flex flex-col divide-y">
        <div class="flex flex-row"></div>
        <div class="flex flex-row"></div>
      </div>

      <div
        class="flex h-2 w-full flex-grow flex-col overflow-y-auto"
        *ngIf="builderLeft === builderLeftTree"
      >
        <ng-scrollbar
          class="ml-6"
          [orientation]="'vertical'"
          [visibility]="'hover'"
          [appearance]="'compact'"
        >
          <div class="mt-2 h-full w-full">
            <div *ngIf="!!word" class="mr-5">
              <div
                *ngFor="let fileItem of filteredFileItems"
                class="hover:bg-m50 group flex flex-row items-center rounded py-2 pl-3 pr-3 hover:cursor-pointer"
                [ngClass]="{
                  'bg-m50': fileId === fileItem.fileId
                }"
                (click)="fileItemOnClick(fileItem.fileId)"
              >
                <div class="flex flex-col">
                  <div
                    class="truncate text-base"
                    [ngClass]="{
                      'text-m600 font-semibold': fileId === fileItem.fileId,
                      'text-s1': fileId !== fileItem.fileId
                    }"
                  >
                    {{ fileItem.fileName }}
                  </div>

                  <div
                    class="truncate text-base"
                    [ngClass]="{
                      'text-m600': fileId === fileItem.fileId,
                      'text-s400': fileId !== fileItem.fileId
                    }"
                  >
                    {{ fileItem.parentPath }}
                  </div>
                </div>

                <div class="flex-grow"></div>

                <m-files-right-panel-toggle
                  class="ml-5"
                  [fileNodeId]="fileItem.fileNodeId"
                  [secondFileNodeId]="secondFileNodeId"
                  [needValidate]="nav?.needValidate === true"
                  [repoConflictsIsEmpty]="repo?.conflicts?.length === 0"
                  [structErrorsIsEmpty]="struct?.errors?.length === 0"
                ></m-files-right-panel-toggle>
              </div>
            </div>

            <tree-root
              [ngClass]="{
                hidden: !!word
              }"
              class="w-full"
              #itemsTree
              [nodes]="repo?.nodes"
              [options]="treeOptions"
              (initialized)="treeOnInitialized()"
              (updateData)="treeOnUpdateData()"
              (moveNode)="onMoveNode($event)"
            >
              <ng-template #treeNodeTemplate let-node="node">
                <div
                  class="flex h-11 w-full flex-row pr-5"
                  *ngIf="node.parent !== null && !node.parent.data.virtual"
                >
                  <div
                    data-cy="filesTreeItem"
                    (click)="nodeOnClick(node)"
                    class="hover:bg-m50 mycls group flex w-full cursor-pointer select-none flex-row rounded"
                    [style.padding-left.px]="(node.level - 2) * 12"
                    [ngClass]="{
                      'text-m600 bg-m50 font-semibold':
                        !!fileNodeId && node.data.id === fileNodeId
                    }"
                  >
                    <div
                      class="relative flex w-full flex-row items-center rounded py-1 pr-2"
                      [ngClass]="{
                        'pl-3': !node.data.isFolder,
                        'pl-4':
                          node.data.isFolder === true &&
                          !!node.data.parent?.data?.parent
                      }"
                    >
                      <div class="ml-3 flex min-w-[2px] items-center">
                        <div
                          *ngIf="node.data.isFolder"
                          class="flex flex-shrink-0 flex-row space-x-1"
                        >
                          <div class="h-6 w-6" *ngIf="!node.hasChildren"></div>
                          <m-chevron-right-icon
                            class="text-s500"
                            *ngIf="!node.isExpanded && node.hasChildren"
                          ></m-chevron-right-icon>
                          <m-chevron-down-icon
                            class="text-s500"
                            *ngIf="node.isExpanded && node.hasChildren"
                          ></m-chevron-down-icon>

                          <m-folder-closed-icon
                            class="text-m500"
                            *ngIf="!node.isExpanded || !node.hasChildren"
                          ></m-folder-closed-icon>
                          <m-folder-open-icon
                            class="text-m600"
                            *ngIf="node.isExpanded && node.hasChildren"
                          ></m-folder-open-icon>
                        </div>

                        <div
                          *ngIf="
                            !node.data.isFolder &&
                            !!fileNodeId &&
                            node.data.id === fileNodeId
                          "
                          data-cy="filesSelectedSymbol"
                          class="bg-m600 text-m0 h-9 w-[6px] focus:outline-none"
                        ></div>

                        <div
                          *ngIf="
                            !node.data.isFolder &&
                            (!fileNodeId || node.data.id !== fileNodeId)
                          "
                          class="h-9 w-[6px]"
                        ></div>

                        <div
                          *ngIf="!node.data.isFolder"
                          class="ml-3 w-7 flex-shrink-0 text-center font-bold"
                        >
                          <m-document-icon></m-document-icon>
                        </div>

                        <div class="ml-2 min-w-[2px] truncate text-base">
                          {{
                            node.parent === null || node.parent.data.virtual
                              ? (projectName$ | async | capitalize)
                              : node?.data.name
                          }}
                        </div>
                      </div>

                      <div class="flex-grow"></div>

                      <m-files-right-panel-toggle
                        *ngIf="node.data.isFolder === false"
                        class="ml-3"
                        [fileNodeId]="node.data.id"
                        [secondFileNodeId]="secondFileNodeId"
                        [needValidate]="nav?.needValidate === true"
                        [repoConflictsIsEmpty]="repo?.conflicts?.length === 0"
                        [structErrorsIsEmpty]="struct?.errors?.length === 0"
                      ></m-files-right-panel-toggle>

                      <div
                        class="ml-3 h-9 w-9 flex-shrink-0"
                        *ngIf="nav.repoType === repoTypeEnum.Production"
                      ></div>

                      <div
                        *ngIf="nav.repoType !== repoTypeEnum.Production"
                        class="text-s1 invisible ml-3 flex flex-shrink-0 group-hover:visible"
                      >
                        <m-folder-options
                          *ngIf="node.data.isFolder"
                          [node]="node"
                        ></m-folder-options>

                        <m-file-options
                          *ngIf="!node.data.isFolder"
                          [node]="node"
                        ></m-file-options>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </tree-root>
          </div>
        </ng-scrollbar>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="builderLeft !== builderLeftTree && builderLeft !== builderLeftInfo"
  class="bg-m0 flex h-full w-full flex-grow rounded shadow"
>
  <div class="text-s1 mt-6 flex w-full flex-col text-base">
    <div class="flex flex-1 flex-col">
      <div class="mb-6 ml-6 mr-9 flex h-11 flex-row items-center">
        <div
          class="ml-3 flex w-[150px] cursor-pointer flex-row items-center"
          (click)="subNavToCommitOnClick()"
        >
          <div
            class="flex select-none items-center text-lg"
            [ngClass]="{
              'text-m500 font-semibold':
                builderLeft === builderLeftChangesToCommit,
              'text-s500': builderLeft !== builderLeftChangesToCommit
            }"
          >
            To commit ({{ repo?.changesToCommit?.length }})
          </div>
        </div>

        <div
          class="ml-3 flex w-[135px] flex-row items-center"
          [ngClass]="{
            'cursor-pointer': !(repo?.changesToCommit?.length > 0),
            'cursor-default': repo?.changesToCommit?.length > 0
          }"
          [tp]="templateToPush"
          [tpIsEnabled]="
            needSave === true ||
            repo?.changesToCommit?.length > 0 ||
            (repo?.changesToPush?.length === 0 &&
              repo.repoStatus === repoStatusNeedPush)
          "
          (click)="subNavToPushOnClick()"
        >
          <div
            class="flex select-none items-center text-lg"
            [ngClass]="{
              'text-m500 font-semibold':
                builderLeft === builderLeftChangesToPush,
              'text-s500': builderLeft !== builderLeftChangesToPush
            }"
          >
            To push<ng-container *ngIf="!(repo?.changesToCommit?.length > 0)">
              ({{ repo?.changesToPush?.length }})</ng-container
            >
          </div>
        </div>
      </div>

      <div class="divide-s300 ml-6 mr-9 flex flex-col divide-y">
        <div class="flex flex-row"></div>
        <div class="flex flex-row"></div>
      </div>

      <div class="flex h-2 w-full flex-grow flex-col overflow-y-auto">
        <ng-scrollbar
          [orientation]="'vertical'"
          [visibility]="'hover'"
          [appearance]="'compact'"
        >
          <div
            class="mt-4 h-full w-full"
            *ngIf="
              builderLeft === builderLeftChangesToCommit &&
              repo?.changesToCommit?.length > 0
            "
          >
            <div
              *ngFor="let change of repo.changesToCommit"
              class="hover:bg-m50 ml-6 mr-5 flex flex-row items-center rounded py-2 pl-3 pr-6 hover:cursor-pointer"
              [ngClass]="{
                'bg-m50': fileId === change.fileId
              }"
              (click)="changeToCommitOnClick(change.fileId)"
            >
              <div class="flex flex-col">
                <div
                  class="truncate text-base"
                  [ngClass]="{
                    'text-m600 font-semibold': fileId === change.fileId,
                    'text-s1': fileId !== change.fileId
                  }"
                >
                  {{ change.fileName }}
                </div>

                <div
                  class="truncate text-base"
                  [ngClass]="{
                    'text-m600': fileId === change.fileId,
                    'text-s400': fileId !== change.fileId
                  }"
                >
                  {{ change.parentPath }}
                </div>
              </div>

              <div class="flex-grow"></div>

              <div class="text-s400 ml-3 flex-shrink-0 text-base">
                {{ change.status }}
              </div>
            </div>
          </div>
        </ng-scrollbar>

        <ng-scrollbar
          [orientation]="'vertical'"
          [visibility]="'hover'"
          [appearance]="'compact'"
        >
          <div
            class="mt-4 h-full w-full"
            *ngIf="
              builderLeft === builderLeftChangesToPush &&
              repo?.changesToPush?.length > 0
            "
          >
            <div
              *ngFor="let change of repo.changesToPush"
              class="hover:bg-m50 ml-6 mr-5 flex flex-row items-center rounded py-2 pl-3 pr-6 hover:cursor-pointer"
              [ngClass]="{
                'bg-m50': fileId === change.fileId
              }"
              (click)="changeToPushOnClick(change.fileId)"
            >
              <div class="flex w-full flex-col">
                <div
                  class="truncate text-base"
                  [ngClass]="{
                    'text-m600 font-semibold': fileId === change.fileId,
                    'text-s1': fileId !== change.fileId
                  }"
                >
                  {{ change.fileName }}
                </div>

                <div
                  class="truncate text-base"
                  [ngClass]="{
                    'text-m600': fileId === change.fileId,
                    'text-s400': fileId !== change.fileId
                  }"
                >
                  {{ change.parentPath }}
                </div>
              </div>

              <div class="flex-grow"></div>

              <div class="text-s400 ml-3 flex-shrink-0 text-base">
                {{ change.status }}
              </div>
            </div>
          </div>
        </ng-scrollbar>

        <div
          *ngIf="
            builderLeft === builderLeftChangesToCommit &&
            repo?.changesToCommit?.length === 0
          "
          class="flex h-full w-full flex-col items-center justify-center"
        >
          <m-completed-ring></m-completed-ring>
          <div class="mt-4 text-xl"> No changes to Commit</div>
        </div>

        <div
          *ngIf="
            builderLeft === builderLeftChangesToPush &&
            repo?.changesToPush?.length === 0 &&
            repo.repoStatus !== repoStatusNeedPush &&
            repo?.changesToCommit?.length > 0
          "
          class="flex h-full w-full flex-col items-center justify-center"
        >
          <div class="text-xl">Commit to see Changes to Push</div>
        </div>

        <div
          *ngIf="
            builderLeft === builderLeftChangesToPush &&
            repo?.changesToPush?.length === 0 &&
            repo.repoStatus !== repoStatusNeedPush &&
            !(repo?.changesToCommit?.length > 0)
          "
          class="flex h-full w-full flex-col items-center justify-center"
        >
          <m-completed-ring></m-completed-ring>
          <div class="mt-4 text-xl"> No committed changes to Push</div>
        </div>

        <div
          *ngIf="
            builderLeft === builderLeftChangesToPush &&
            repo?.changesToPush?.length === 0 &&
            repo.repoStatus === repoStatusNeedPush
          "
          class="flex h-full w-full flex-col items-center justify-center"
        >
          <div class="text-a500">
            <m-alert-ring></m-alert-ring>
          </div>
          <div class="mt-4 text-xl"> Push branch to Remote</div>
        </div>
      </div>
    </div>
  </div>
</div>

<m-session-info
  *ngIf="builderLeft === builderLeftInfo"
  class="flex h-full w-full flex-grow"
></m-session-info>

<div *ngIf="struct$ | async"></div>
<div *ngIf="repo$ | async"></div>
<div *ngIf="nav$ | async"></div>
<div *ngIf="needSave$ | async"></div>
<div *ngIf="secondFileNodeId$ | async"></div>
<div *ngIf="file$ | async"></div>

<ng-template #templateToPush>
  <div *ngIf="needSave === true">Need to Save changes</div>
  <div *ngIf="needSave === false && repo?.changesToCommit?.length > 0">
    Commit to see Changes to Push
  </div>
  <div
    *ngIf="
      needSave === false &&
      repo?.changesToCommit?.length === 0 &&
      repo?.changesToPush?.length === 0 &&
      repo.repoStatus === repoStatusNeedPush
    "
  >
    Push branch to Remote
  </div>
</ng-template>
